export default "__VITE_ASSET__D9hCcHV6__"